import React, {Component} from 'react';

class Register extends Component {
    onFieldChange(fieldName, e) {
        if (typeof this.props.handleInputChange === 'function') {
            this.props.handleInputChange(fieldName, e.target.value)
        }
    }

    render() {
        let validField = this.props.validField;
        let errorMessageEmail = '';
        let errorMessagePassword = '';
        let errorMessagePasswordConfirmation = '';
        let errorMessageFirstName = '';
        let errorMessageLastName = '';

        for (let el in validField) {
            if (el === 'email' && validField[el] === 'invalid') {
                errorMessageEmail = <em id="email-error" class="state-error">Please enter a valid email address.</em>
            } else if (el === 'email' && validField[el] === 'empty') {
                errorMessageEmail = <em id="email-error" class="state-error">Please enter email address.</em>
            } else if (el === 'password' && validField[el] === 'empty') {
                errorMessagePassword = <em id="email-error" class="state-error">Please enter password.</em>
            } else if (el === 'password' && validField[el] === 'less') {
                errorMessagePassword = <em id="email-error" class="state-error">Please enter a valid password.</em>
            } else if (el === 'passwordConfirmation' && validField[el] === 'not_match') {
                errorMessagePasswordConfirmation = <em id="email-error" class="state-error">Please enter a valid confirmation password.</em>
            } else if (el === 'passwordConfirmation' && validField[el] === 'empty') {
                errorMessagePasswordConfirmation = <em id="email-error" class="state-error">Please enter confirmation password.</em>
            } else if (el === 'firstName' && validField[el] === 'empty') {
                errorMessageFirstName = <em id="email-error" class="state-error">Please enter first name.</em>
            } else if (el === 'firstName' && validField[el] === 'many') {
                errorMessageFirstName = <em id="email-error" class="state-error">First name is too more.</em>
            } else if (el === 'lastName' && validField[el] === 'empty') {
                errorMessageLastName = <em id="email-error" class="state-error">Please enter last name.</em>
            } else if (el === 'lastName' && validField[el] === 'many') {
                errorMessageLastName = <em id="email-error" class="state-error">Last name is too more.</em>
            }
        }

        return (
            <div id="ctr_personal" className="hiddenbox">
                <div className="frm-row">
                    <div className="section colm colm6">
                        <label className={Object.keys(errorMessageFirstName).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                            <input
                                type="text"
                                name="firstname"
                                id="firstname"
                                className="gui-input"
                                placeholder="First name..."
                                onChange={this.onFieldChange.bind(this, 'firstName')}
                            />
                            <span className="field-icon"><i className="fa fa-user"></i></span>
                        </label>
                        {
                            errorMessageFirstName
                        }
                    </div>
                    <div className="section colm colm6">
                        <label className={Object.keys(errorMessageLastName).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                            <input
                                type="text"
                                name="lastname"
                                id="lastname"
                                className="gui-input"
                                placeholder="Last name..."
                                onChange={this.onFieldChange.bind(this, 'lastName')}
                            />
                            <span className="field-icon"><i className="fa fa-user"></i></span>
                        </label>
                        {
                            errorMessageLastName
                        }
                    </div>
                </div>
                <div className="section">
                    <label for="email" className="field-label">Your email address</label>
                    <label className={Object.keys(errorMessageEmail).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                        <input
                            type="email"
                            name="email"
                            id="email"
                            className="gui-input"
                            placeholder="example@domain.com..."
                            onChange={this.onFieldChange.bind(this, 'email')}
                        />
                        <span className="field-icon"><i className="fa fa-envelope"></i></span>
                    </label>
                    {
                        errorMessageEmail
                    }
                </div>
                <div className="section">
                    <label for="password" className="field-label">Create a password</label>
                    <label className={Object.keys(errorMessagePassword).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                        <input
                            type="password"
                            name="password"
                            id="password"
                            className="gui-input"
                            onChange={this.onFieldChange.bind(this, 'password')}
                        />
                        <span className="field-icon"><i className="fa fa-lock"></i></span>
                    </label>
                    {
                        errorMessagePassword
                    }
                </div>
                <div className="section">
                    <label for="confirmPassword" className="field-label">Confirm your password</label>
                    <label className={Object.keys(errorMessagePasswordConfirmation).length > 0 ? "field prepend-icon state-error" : 'field prepend-icon'}>
                        <input
                            type="password"
                            name="confirmPassword"
                            id="confirmPassword"
                            className="gui-input"
                            onChange={this.onFieldChange.bind(this, 'confirmPassword')}
                        />
                        <span className="field-icon"><i className="fa fa-unlock-alt"></i></span>
                    </label>
                    {
                        errorMessagePasswordConfirmation
                    }
                </div>
            </div>
        )
    }
}

export default Register;


/** WEBPACK FOOTER **
 ** ./src/Register.js
 **/